<template>
  <div class="container-fluid">
    <h3 class="mb-4">Invoice Alat Optik</h3>
    <DetailTop v-if="detailTop" :detailTop="detailTop" />
    <div class="row">
      <div class="col-md-12" style="position: relative">
        <div class="d-flex flex-between my-3" v-if="optik.length">
          <h5 class="mb-2">Resep Optik</h5>
        </div>
        <table class="responsive" v-if="optik.length">
          <thead>
            <th>KODE</th>
            <th>NAMA BARANG</th>
            <th>JENIS OBAT</th>
            <th>LOKASI</th>
            <th>HARGA/SATUAN</th>
            <th>JUMLAH</th>
            <th>EMBALASE</th>
            <th>TUSLAH</th>
            <th>SUB TOTAL</th>
          </thead>
          <tbody>
            <tr v-for="item in optik" v-bind:key="item.id + Math.random(1024)">
              <td>{{ item.optik.kode }}</td>
              <td>{{ item.optik.nama }}</td>
              <td>{{ item.optik.jenis }}</td>
              <td>{{ item.optik.lokasi }}</td>
              <td>{{ item.formatted_harga }}</td>
              <td>{{ item.jumlah }}</td>
              <td>{{ item.formatted_embalase }}</td>
              <td>{{ item.formatted_tuslah }}</td>
              <td>{{ item.formatted_sub_total }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"></td>
              <td colspan="5">
                <h4 class="my-2">Total Biaya Optik</h4>
              </td>
              <td colspan="1" class="text-right">
                <h4 class="my-2">{{ convertToRupiah(optik_count) }}</h4>
              </td>
            </tr>
          </tfoot>
        </table>
        <hr />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-6">
        <h4 class="mb-4">Ringkasan</h4>
        <div class="card px-4 py-3 my-2" v-if="ringkasan">
          <div class="row">
            <div class="col-md-12">
              <div class="row mb-4">
                <div class="col-md-6">
                  <span
                    :class="
                      `badge badge-${
                        ringkasan.status == 'BELUM DIBAYAR'
                          ? 'danger'
                          : ringkasan.status == 'BELUM LUNAS'
                          ? 'warning'
                          : 'primary'
                      }`
                    "
                    >{{ ringkasan.status }}</span
                  >
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Nomor Pembayaran</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0">
                    {{ ringkasan ? ringkasan.no_pembayaran : "" }}
                  </h4>
                </div>
              </div>
              <hr />
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0">
                    {{
                      ringkasan
                        ? convertToRupiah(ringkasan.total_bayar)
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3" v-if="ringkasan.ditanggung">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Ditanggung</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="">
                    {{
                      ringkasan ? convertToRupiah(ringkasan.ditanggung) : "Rp 0"
                    }}
                  </h4>
                  <h5 class="text-secondary">
                    Ditanggung oleh {{ asuransi[id_asuransi] }}
                  </h5>
                  <!-- <div class="card p-2 my-3" style="background:#7f8f9">
                    <p class="mb-1">Ditanggung oleh {{asuransi[id_asuransi]}}</p>
                    <h5 class="mb-0">Ditanggung oleh {{asuransi[id_asuransi]}}</h5>
                </div> -->
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Yang harus dibayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0 text-info">
                    {{
                      ringkasan
                        ? convertToRupiah(
                            ringkasan.total_bayar - ringkasan.ditanggung
                          )
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Telah dibayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="text-primary">
                    {{
                      ringkasan ? convertToRupiah(ringkasan.dibayar) : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <h4 class="mb-0 text-muted">Sisa bayar</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="mb-0 text-danger">
                    {{
                      ringkasan
                        ? convertToRupiah(ringkasan.sisa_tagihan)
                        : "Rp 0"
                    }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loading v-else />
      </div>
      <div class="col-md-6">
        <h4 class="mb-4">Riwayat Pembayaran</h4>
        <b-row v-if="ringkasan && riwayat">
          <b-col md="12">
            <table class="responsive">
              <thead v-if="riwayat && riwayat.length">
                <th>TANGGAL</th>
                <th>JAM</th>
                <th>CARA BAYAR</th>
                <th>JUMLAH PEMBAYARAN</th>
              </thead>
              <tbody v-if="riwayat && riwayat.length">
                <tr
                  v-for="item in riwayat"
                  v-bind:key="item.id + Math.random(1024)"
                >
                  <td>{{ item.formatted_tanggal }}</td>
                  <td>{{ item.formatted_jam }}</td>
                  <td>
                    {{ item.cara_bayar
                    }}{{ item.no_kartu ? " - " + item.no_kartu : "" }}
                  </td>
                  <td>{{ item.formatted_jumlah }}</td>
                </tr>
              </tbody>
              <tfoot v-if="riwayat && riwayat.length">
                <tr>
                  <td colspan="2"></td>
                  <td>
                    <h4 class="my-2">SISA PEMBAYARAN</h4>
                  </td>
                  <td colspan="1" class="text-right">
                    <h4 class="mt-2 mb-2">
                      {{
                        ringkasan
                          ? convertToRupiah(ringkasan.sisa_tagihan)
                          : "Rp 0"
                      }}
                    </h4>
                  </td>
                </tr>
              </tfoot>
              <tfoot v-else>
                <tr>
                  <td style="padding-left: 0 !important">
                    <p>Belum ada Riwayat Pembayaran di sini</p>
                  </td>
                  <td colspan="1" class="text-right"></td>
                </tr>
              </tfoot>
            </table>
          </b-col>
        </b-row>
        <Loading v-else />
      </div>
    </div>

    <!--/form-->
  </div>
</template>

<script>
// @ is an alias to /src
// import Alert from '@/components/Alert.vue'
// import SearchResult from '@/components/SearchResult.vue'
// import Navbar from '@/components/Navbar.vue'
// import Sidebar from '@/components/Sidebar.vue'
// import FormRow from '@/components/FormRow.vue'
import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from '@/components/DetailLeft.vue'
// import DetailRight from '@/components/DetailRight.vue'
import Loading from "@/components/Loading.vue";
// import FormData from "form-data";
import { setBayarIntro, convertToRupiah } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { data, jumlahForm, bayarForm } from "@/data/KasirForm.js";

export default {
  name: "KasirInvoiceOptik",
  components: {
    DetailTop,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      id_asuransi: null,
      id_ralan: "",
      lunas: false,
      visible: false,
      tab: "rincian",
      data: data,
      convertToRupiah: convertToRupiah,
      history: [],
      asuransi: { 1: "Umum", 2: "BPJS", 3: "Asuransi" },
      jumlahForm: jumlahForm,
      bayarForm: bayarForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        id_tagihan_ringkasan: "",
        jumlah: "",
        cara_bayar: "",
        no_kartu: "",
        lunas: [],
      },
      n: 0,
      optik: [],
      optik_count: 0,
      isError: false,
      ringkasan: null,
      riwayat: null,
    };
  },
  methods: {
    fetchRingkasan: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.ringkasan = result.data;
          let resultRalan = await this.$store.state.HTTP.get(
            `ralan/${this.id_ralan}`
          );
          this.id_asuransi = resultRalan?.data?.id_asuransi;
          //console.log(resultRalan);
          this.detailTop = setBayarIntro(resultRalan.data);
          let resultOptik = await this.$store.state.HTTP.get(
            `ralan/barang/optik?no_rawat=${resultRalan.data.no_rawat}`
          );
          if (resultOptik.status == 200) {
            //console.log(resultOptik);
            let that = this;
            this.optik = resultOptik.data.data;
            this.optik_count = 0;
            this.optik.forEach((item) => {
              //console.log(item);
              that.optik_count += item.sub_total;
            });
          }
          this.print();
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchRiwayat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_pembayaran?id_tagihan_ringkasan=${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.riwayat = result.data.data;
          this.print();
          //console.log(this.riwayat);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    init: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      this.fetchRingkasan();
      this.fetchRiwayat();
    },
    print: async function() {
      if (this.ringkasan && this.riwayat)
        setTimeout(function() {
          window.print();
        }, 1000);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.init();
  },
};
</script>
